module.exports = __webpack_public_path__ + "media/images/top/title_r-ff2182180c8ba98c0947e78dd7ad1d50.gif";